module.exports = __webpack_public_path__ + "img/cxample_01.e23aeff8.png";